@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}
<div class="span9">
  <h1>Vtns</h1>
</div>
<p class="lead">
  VTNs are the 'server' in the VEN-VTN client-server relationship. They
  distribute events to many VENs or schedule reports to be sent to them from a
  VEN. One VTN may be associated to many VENs.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align: right">
    <a
      id="createVtn"
      class="btn btn-large btn-primary"
      (click)="nextPage($event, '/createVtn', router)"
      style="margin-top: 9px"
    >
      Create VTN</a
    >
  </div>
}
@if(isLoading) {
  <app-loader
    message="Loading VTNs...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <tr>
      <th>ID</th>
      <th>VTN ID</th>
      <th>URI</th>
      <th>Mode</th>
      <th>CA fingerprint</th>
      <th>Push Fingerprint</th>
      <th># Vens</th>
      <th>Last Modified By</th>
      <th>Health</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="VTN ID" class="input-sm form-control" type="search" [(ngModel)]="vtnIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="URI" class="input-sm form-control" type="search" [(ngModel)]="uriSearch" (input)="triggerSearch()"/></th>
      <th>
        <select class="input-sm form-control" [(ngModel)]="modeSearch" (change)="triggerSearch()">
          <option value="">All</option>
          <option value="push">Push</option>
          <option value="poll">Poll</option>
        </select>
      </th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(vtn of displayedVtns | paginate: paginationModel; track vtn) {
        <tr class="table-active">
          <td>{{ vtn.id }}</td>
          <td>{{ vtn.vtn_id }}</td>
          <td>{{ vtn.uri }}</td>
          <td>
            <span class="badge badge-primary">
              {{ vtn.mode | titlecase }}
            </span>
          </td>
          <td>{{ vtn.mode === 'poll' ? vtn.ca : 'N/A' }}</td>
          <td>{{ vtn.mode === 'push' ? (vtn.fingerprint || 'Not set') : 'N/A' }}</td>
          <td>{{ vtn.vens.length }}</td>
          <td id="updated_by">{{ vtn.updated_by }}</td>
          <td>
            <span [ngClass]="vtnClass(vtn)" aria-hidden="true"></span>
            {{ vtn.status }}
          </td>

          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a
                  class="btn btn-default"
                  (click)="nextPage(vtn.id, '/editVtn', router)"
                  name="editVtn"
                >Edit</a
                >
                <button class="btn btn-danger" type="button" (click)="delete(vtn)">
                  Delete
                </button>
                @if(vtn.status === 'unhealthy' && vtn.mode === 'poll') {
                  <button
                    id="clear_failures"
                    class="btn btn-success"
                    type="button"
                    (click)="clear_failures(vtn)"
                  >
                    Reset health
                  </button>
                }
              </div>
            </td>
          }
        </tr>
      }
      @if(displayedVtns.length === 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 10 : 9" style="text-align: center">No VTNs found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 10 : 9">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
